module.exports = __webpack_public_path__ + "static/media/shredder.d119c95f.svg";